/** Constants and the terms-required signal shared by `api.ts` and `legal.ts` (kept apart to avoid an import cycle). */
export const PORTAL = "customer";
export const TERMS_REQUIRED = "TERMS_ACCEPTANCE_REQUIRED";
export const VERSION_NOT_CURRENT = "LEGAL_VERSION_NOT_CURRENT";

const listeners = new Set<() => void>();

/** Raised whenever a portal call is refused because mandatory policies are outstanding. */
export const termsRequired = {
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  notify(): void {
    for (const l of [...listeners]) l();
  },
};
